// extracted by mini-css-extract-plugin
module.exports = {"addCompanyWrp":"addCompany_addCompanyWrp__3Tm0h","selectorWrp":"addCompany_selectorWrp__HvCC7","loaderWrp":"addCompany_loaderWrp__3K9uC"};